import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../constants/appRoutes';
import { PhotoContext } from '../../context/PhotoProvider';
import styles from './styles.module.scss';
import '../../App.scss';
import { ProductTypes } from '../../types/enums';
import NavButton from '../../components/NavButton';
import Block from '../../components/Block';

const dataByTypeMap = {
  [ProductTypes.MOSAIC]: {
    getInstructionLink: (order: string) =>
      APP_ROUTES.INTERACTIVE_INSTRUCTION + order,
    linkText: 'interactiveInstructions',
    linkButtonText: 'startAssembly',
    pdfLinkText: 'downloadPDFInstructions',
  },
  [ProductTypes.PAINTING]: {
    getInstructionLink: () => APP_ROUTES.PAINTING_TUTORIAL,
    linkText: 'paintingInstructionTitle',
    linkButtonText: 'open',
    pdfLinkText: 'downloadPDFPaintingInstructions',
  },
  [ProductTypes.EMBROIDERY]: {
    getInstructionLink: (order: string) =>
      APP_ROUTES.EMBROIDERY_INTERACTIVE_INSTRUCTION + order,
    linkText: 'interactiveEmbroideryInstructions',
    linkButtonText: 'startAssembly',
    pdfLinkText: 'downloadPDFInstructions',
  },
  [ProductTypes.DOT_PAINTING]: {
    getInstructionLink: (order: string) =>
      APP_ROUTES.DOT_PAINTING_INTERACTIVE_INSTRUCTION + order,
    linkText: 'interactiveDotPaintingInstructions',
    linkButtonText: 'startAssembly',
    pdfLinkText: 'downloadPDFInstructions',
  },
};

const InstructionLink = () => {
  const navigate = useNavigate();
  const { pdfUrl, order, productType } = useContext(PhotoContext);
  const location = useLocation();
  const { t } = useTranslation();

  const email = location.state?.email;
  const navigateHome = () => {
    navigate(APP_ROUTES.MAIN_PAGE);
  };
  const navigateInteractiveInstruction = () => {
    navigate(dataByTypeMap[productType].getInstructionLink(order));
  };

  const openPdf = () => {
    window.open(pdfUrl, '_blank');
  };

  return (
    <div className={styles.contentContainer}>
      <h1>{t('Your instruction is ready!')}</h1>
      <h4 className={styles.mail}>
        {t('The instruction has been sent to your')} {email}
      </h4>
      <Block
        size="small"
        type={productType}
        isLongText
        color="pink"
        text="You can start assembling the mosaic right now using the interactive instructions."
        buttonText="Start Assembling"
        buttonAction={navigateInteractiveInstruction}
      />
      <Block
        size="small"
        type={productType}
        isLongText
        color="blue"
        text="Or download the PDF file, which can be opened on any device or printed:"
        buttonText="Download PDF"
        buttonAction={openPdf}
      />
      <NavButton type="back" text="Back to Home page" onClick={navigateHome} />
    </div>
  );
};

export default InstructionLink;
